<template>
  <a-drawer
    v-if="project"
    class="part drawer project-briefing"
    width="720"
    :title="'Project Briefing'"
    placement="right"
    :closable="true"
    :visible="visible"
    :after-visible-change="afterVisibleChange"
    @close="onClose"
  >
    <div class="inner">
      <a-descriptions :title="'Project Briefing (' + project._id + ')'" size="small" :column="2" bordered>
        <template v-if="project.customer">
          <a-descriptions-item label="Name" v-if="project.customer.name">
            <span> {{ project.customer.name }}</span>
            <span v-if="project.customer.last_name">
              {{ project.customer.last_name }}
            </span>
          </a-descriptions-item>

          <a-descriptions-item label="Phone" v-if="project.customer.phone">
            <span> {{ project.customer.phone }}</span>
            <span v-if="project.customer.phone_extension"> Ext. {{ project.customer.phone_extension }} </span>
          </a-descriptions-item>

          <a-descriptions-item label="Email" v-if="project.customer.email">
            <span> {{ project.customer.email }}</span>
          </a-descriptions-item>

          <a-descriptions-item label="WeChat" v-if="project.customer.wechat">
            <span> {{ project.customer.wechat }}</span>
          </a-descriptions-item>
        </template>

        <a-descriptions-item label="Start Date" v-if="project.start_date">
          <span> {{ project.start_date | moment('LL') }}</span>
        </a-descriptions-item>

        <a-descriptions-item label="Property" v-if="project.property">
          <span> {{ project.property | PROPERTY_ }}</span>
        </a-descriptions-item>

        <a-descriptions-item label="Services" v-if="project.services">
          <span v-for="service in project.services" :key="service"> {{ service | SERVICE_ }} . </span>
        </a-descriptions-item>

        <a-descriptions-item label="Location" v-if="project.location">
          <span> {{ project.location }}</span>
        </a-descriptions-item>

        <a-descriptions-item label="Address" span="2" v-if="project.raw_address">
          <span> {{ project.raw_address }}</span>
        </a-descriptions-item>

        <a-descriptions-item label="Description" span="2" v-if="project.description">
          <span> {{ project.description }}</span>
        </a-descriptions-item>

        <a-descriptions-item label="Note" span="2" v-if="project.note">
          <span> {{ project.note }}</span>
        </a-descriptions-item>
      </a-descriptions>
    </div>
    <textarea class="textarea" name="textarea" rows="20" v-model="briefing" readonly />
    <!-- {{ project }} -->
  </a-drawer>
</template>
<script>
const KEY = 'BRIEFING'

export default {
  name: 'project-briefing-drawer',
  computed: {
    project() {
      return this.$store.getters['pm/data']('project')
    },
    briefing() {
      let str = ''
      if (this.project) {
        if (this.project._id) str += `● Order#: ${this.project._id}`
        if (this.project.customer) {
          str += `\n● Name: ${this.project.customer.name || 'No Name'} ${this.project.customer.last_name || ''}`
          str += `\n● Phone: ${this.project.customer.phone || 'n/a'}${
            this.project.customer.phone_extension ? ' Ext.' + this.project.customer.phone_extension : ''
          }`
          if (this.project.customer.email) str += `\n● Email: ${this.project.customer.email}`
          // if (this.project.customer.wechat) str += `\n● WeChat: ${this.project.customer.wechat}`
        }
        if (this.project.start_date) str += `\n● Start Date: ${this.$moment(this.project.start_date).format('LL')}`
        if (this.project.property && this.project.property !== '') {
          str += `\n● Property: ${this.options_.PROPERTY_TYPES.find((pt) => pt.key === this.project.property).value}`
        }
        if (this.project.services && this.project.services.length && this.project.services.every((s) => s !== '')) {
          str += `\n● Services: ${this.project.services.map((s) => {
            return this.options_.SERVICE_TYPES.find((ss) => ss.key === s).value
          })}`
        }

        if (this.project.location) str += `\n● Location: ${this.project.location}`
        if (this.project.raw_address) str += `\n● Address: ${this.project.raw_address}`
        if (this.project.description) str += `\n● Description: ${this.project.description}`
        str += `\n\n(Note: Please contact the customer as soon as possible)`
      }

      return str
    },
    visible: {
      get() {
        return this.$store.getters['pm/UI_VISIBLE'](KEY)
      },
      set(visible) {
        this.$store.dispatch('pm/UI_VISIBLE', { key: KEY, visible })
      },
    },
  },
  methods: {
    afterVisibleChange(val) {
      // console.log('visible', val)
    },
    showDrawer() {
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
  },
  mounted() {
    // console.log(this.project)
  },
}
</script>

<style lang="scss" scoped>
.textarea {
  margin-top: 1rem;
  width: 100%;
  padding: 1rem;
  border: unset;
  border-radius: 3px;
  outline: none;
  background: #f3f9ff;
  font-size: 1.1rem;
  line-height: 2;
}
</style>
